// extracted by mini-css-extract-plugin
var _1 = "DayPicker-module__animatedBackground--_2lJG";
var _2 = "DayPicker-module__dayPicker--QioRm";
export { _1 as "animatedBackground", _2 as "dayPicker" }
